import { AppRoute } from '../../enums/appRoutes';

/**
 * The GA `pagename` each route reports in its own page view. Kept here so components
 * rendered outside a page (e.g. the header) can report the page they were used on.
 */
const gaPageNames: Record<string, string> = {
  [AppRoute.LANDING]: 'landing',
  [AppRoute.APPLIANCE_DETAILS]: 'appliance-type',
  [AppRoute.MAINTENANCE]: 'maintenance',
  [AppRoute.MODEL_SERIAL]: 'model-serial',
  [AppRoute.PURCHASE_PRICE]: 'purchase-price',
  [AppRoute.ARRIVAL_DATE]: 'purchase-date',
  [AppRoute.PERSONAL_DETAILS]: 'personal-details',
  [AppRoute.QUOTE]: 'protection-details',
  [AppRoute.CHECKOUT]: 'registration-payment-details',
  [AppRoute.CONFIRMATION]: 'confirmation',
  [AppRoute.ERROR]: 'generic-error',
  [AppRoute.TWO_YEAR_PARTS]: '2-year-parts',
};

/**
 * @description Resolves the GA `pagename` for a pathname. Client specific routes are not
 * in the map, so they fall back to the path itself.
 * @param {string} pathname - The current router pathname, e.g. `/purchase-price`.
 * @returns {string} The GA pagename, e.g. `purchase-price`.
 */
export const getGaPageName = (pathname: string): string =>
  gaPageNames[pathname] ?? (pathname.replace(/^\//, '') || 'unknown');
